import React from "react";
import { Card, CardContent } from "@mui/material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import BuildIcon from "@mui/icons-material/Build";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";

function FuelLogCards({ data }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  if (!data) return null;

  const metrics = [
    {
      title: "Total Fuel Cost",
      value: `₹${(data.totalAmount || 0).toFixed(2)}`,
      icon: <MonetizationOnIcon sx={{ color: "#6366f1", fontSize: "2.2rem" }} />,
    },
    {
      title: "Total Fuel Qty",
      value: `${(data.totalFuelQty || 0).toFixed(1)} L`,
      icon: <LocalGasStationIcon sx={{ color: "#10b981", fontSize: "2.2rem" }} />,
    },
    {
      title: "Avg Rate / L",
      value: `₹${(data.averageRatePerLitre || 0).toFixed(2)}`,
      icon: <BuildIcon sx={{ color: "#f59e0b", fontSize: "2.2rem" }} />,
    },
    {
      title: "Pending Bills",
      value: data.totalPendingBills ?? 0,
      subValue: `₹${Object.values(data.pendingAmountByVendor || {}).reduce((a, b) => a + b, 0).toFixed(2)}`,
      icon: <ReceiptLongIcon sx={{ color: "#ef4444", fontSize: "2.2rem" }} />,
    },
    {
      title: "Payment Mode",
      value: Object.keys(data.paymentModeSummary || {})[0] || "—",
      subValue: `₹${Object.values(data.paymentModeSummary || {})[0]?.toFixed(2) ?? "0.00"}`,
      icon: <CreditCardIcon sx={{ color: "#3b82f6", fontSize: "2.2rem" }} />,
    },
  ];

  return (
    <MDBox
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr", lg: "repeat(5, 1fr)" },
        gap: 3,
        p: 2,
      }}
    >
      {metrics.map((m, i) => (
        <Card
          key={i}
          sx={{
            bgcolor: darkMode ? "#2d3748" : "#fff",
            borderRadius: "16px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            transition: "transform 0.2s, box-shadow 0.2s",
            "&:hover": { transform: "translateY(-4px)", boxShadow: "0 8px 20px rgba(0,0,0,0.12)" },
            minHeight: "140px",
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <MDBox sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <MDBox sx={{ mr: 2.5 }}>{m.icon}</MDBox>
              <MDTypography
                sx={{
                  fontSize: "1.1rem",
                  fontWeight: 600,
                  color: darkMode ? "#fff" : "#1a202c",
                }}
              >
                {m.title}
              </MDTypography>
            </MDBox>

            <MDTypography
              sx={{
                fontSize: "1.8rem",
                fontWeight: 700,
                color: darkMode ? "#fff" : "#2d3748",
              }}
            >
              {m.value}
            </MDTypography>
            {m.subValue && (
              <MDTypography
                sx={{
                  fontSize: "1rem",
                  color: darkMode ? "#94a3b8" : "#718096",
                  mt: 0.5,
                }}
              >
                {m.subValue}
              </MDTypography>
            )}
          </CardContent>
        </Card>
      ))}
    </MDBox>
  );
}

export default FuelLogCards;